import React from "react";
import { Helmet } from "react-helmet";

/** Help page that will fetch faq's posted by organization and Intramu */
export function Help() {
    return (
        <div>
            <Helmet>
                <title>Help</title>
            </Helmet>
            Hopefully someone will help you, its not me
        </div>
    );
}
